/* src/app/component/header/header.component.scss */
:host {
  top: 0;
  position: fixed;
  display: block;
  width: 100%;
  z-index: 999;
}
@media screen and (min-width: 48rem) {
  :host {
    position: sticky;
  }
}
.burger {
  background: none;
  border: none;
  cursor: pointer;
  width: 50px;
  height: 50px;
  display: flex;
  justify-content: center;
  padding: 0;
  margin: 0;
  -webkit-tap-highlight-color: transparent;
}
.burger eon-ui-icon {
  transform: scale(1.5);
}
.mobile-nav-overlay {
  position: fixed;
  transition: all 0.5s ease-in-out;
  inset: 0;
  background: #262626;
  z-index: 1020;
  display: flex;
  flex-direction: column;
  align-items: start;
  justify-content: start;
  padding: 4rem 2rem 2rem 2rem;
  overflow: hidden;
  width: 100vw;
}
.mobile-nav-overlay.hidden {
  opacity: 0;
  left: 100%;
  pointer-events: none;
}
.mobile-nav-overlay.visible {
  opacity: 1;
  left: 0;
  pointer-events: auto;
}
.mobile-nav-overlay .close {
  position: absolute;
  background: none;
  border: none;
  top: 0.25rem;
  right: 0.5rem;
  cursor: pointer;
  width: 50px;
  height: 50px;
  display: flex;
  justify-content: center;
  -webkit-tap-highlight-color: transparent;
}
.mobile-nav-overlay .close eon-ui-icon {
  transform: scale(1.5);
}
.mobile-nav-overlay nav ul {
  display: block;
  padding: 0;
  margin: 0;
}
.mobile-nav-overlay nav ul li {
  list-style: none;
  margin: 0 0 2rem 0;
}
.mobile-nav-overlay nav ul li a {
  color: #ffffff;
  font-size: 2rem;
  text-decoration: none;
}
.mobile-nav-overlay nav ul li a:hover,
.mobile-nav-overlay nav ul li a:focus {
  text-decoration: underline;
}
@media screen and (min-width: 48rem) {
  .burger,
  .mobile-nav-overlay {
    display: none;
  }
  nav,
  .meta-nav,
  .nav__content {
    display: flex;
  }
}
header {
  position: fixed;
  width: 100%;
  margin: 0 auto;
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgba(38, 38, 38, 0.5);
  height: 3.5rem;
  padding: 0.75rem;
}
@media screen and (min-width: 48rem) {
  header {
    padding: 0.75rem 0;
  }
}
header .container--header {
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 0 1rem 0 0;
  min-height: auto;
  height: auto;
}
@media screen and (min-width: 48rem) {
  header .container--header {
    padding: 0 var(--header-padding-left-right, 1rem);
  }
}
header .logo__holder {
  margin-right: 2rem;
  display: flex;
  align-items: center;
  gap: 1rem;
  text-decoration: none;
}
header .logo__holder p {
  margin: 0;
  color: #ffffff;
  font-size: 1rem;
}
header .logo__holder .logo {
  height: 2rem;
  width: auto;
}
@media screen and (min-width: 48rem) {
  header .logo__holder .logo {
    height: 2.5rem;
    width: auto;
  }
}
nav:not(.mobile-nav) {
  display: none;
}
@media screen and (min-width: 48rem) {
  nav:not(.mobile-nav) {
    display: flex;
    align-items: center;
    gap: 1rem;
  }
}
nav:not(.mobile-nav) ul {
  list-style: none;
  margin-bottom: 0;
  height: 100%;
  display: flex;
  flex-direction: row;
}
nav:not(.mobile-nav) ul li {
  display: flex;
  align-self: center;
  margin: 0 1.5rem !important;
  height: 100%;
}
nav:not(.mobile-nav) ul li a,
nav:not(.mobile-nav) ul li span {
  color: #ffffff;
  text-decoration: none;
  height: 100%;
  display: flex;
  align-items: center;
  transition: all ease-in-out 0.3s;
  border-bottom: 2px solid transparent;
  font-size: 1rem;
}
nav:not(.mobile-nav) ul li a:hover,
nav:not(.mobile-nav) ul li a:focus,
nav:not(.mobile-nav) ul li span:hover,
nav:not(.mobile-nav) ul li span:focus {
  border-bottom: 2px solid #ffffff;
}
nav:not(.mobile-nav) ul li a.active,
nav:not(.mobile-nav) ul li span.active {
  border-bottom: 2px solid #ffffff;
}
nav:not(.mobile-nav) ul li span.nav-link {
  cursor: default;
}
nav:not(.mobile-nav).nav__content {
  width: 100%;
  justify-content: end;
}
nav:not(.mobile-nav).nav__content eon-ui-button {
  align-self: flex-end;
}
.meta-nav {
  margin-left: auto;
  align-items: center;
  gap: var(--header-gap, 1rem);
  display: none;
}
@media screen and (min-width: 48rem) {
  .meta-nav {
    display: flex;
  }
}
.meta-nav .user-info {
  display: flex;
}
.meta-nav .user-info .user-id {
  color: #ffffff;
}
.meta-nav .user-info eon-ui-icon {
  cursor: pointer;
  height: 1.5rem;
}
.i18n_switcher {
  margin-left: 1rem;
}
.i18n_switcher button {
  background: none;
  border: none;
  color: #ffffff;
  cursor: pointer;
  font-size: 1rem;
  padding: 0 0.5rem;
  opacity: 0.5;
}
.i18n_switcher button.active {
  font-weight: bold;
  opacity: 1;
}
.i18n_switcher button:hover,
.i18n_switcher button:focus {
  text-decoration: none;
  opacity: 1;
}
.i18n_switcher span {
  border-right: 1px solid #ffffff;
  opacity: 0.5;
}
/*# sourceMappingURL=header.component.css.map */
